import { motion } from "motion/react";
import { Info, ShieldCheck, Mail, Clock } from "lucide-react";

export default function AboutTheProject() {
  return (
    <section id="about-us" className="py-24 bg-white relative">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        
        {/* Left Side: Editorial Content */}
        <div className="lg:col-span-7 space-y-6">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 bg-green-50 border border-green-200 rounded-full text-green-700 text-xs font-bold uppercase tracking-widest">
            <Info className="w-3.5 h-3.5" /> ABOUT THE PROJECT
          </div>
          
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-950 tracking-tight leading-tight">
            About Plant Identifier
          </h2>
          
          <p className="text-base sm:text-lg text-gray-750 font-medium leading-relaxed">
            Plant Identifier is an educational platform designed to help users explore plant species, learn botanical information, and access plant care resources through image-based identification technology.
          </p>

          <p className="text-sm text-gray-500 leading-relaxed font-semibold">
            We aim to foster a deeper appreciation of the natural environment by providing free, highly descriptive, and well-researched plant records. By pairing photo recognition tools with comprehensive cultivation science, we help beginners build the knowledge needed to sustainably grow indoor rooms or outdoor gardens.
          </p>
        </div>

        {/* Right Side: Trust & Contact Summary Card */}
        <div className="lg:col-span-5 bg-gray-50 border border-gray-150 rounded-3xl p-8 space-y-6 shadow-3xs hover:border-green-150 transition-colors">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-green-55/40 border border-green-200 rounded-xl flex items-center justify-center text-green-700">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <div>
              <span className="text-xs text-gray-400 font-bold block uppercase tracking-wider">PLATFORM MISSION</span>
              <span className="text-sm font-black text-gray-950 block">Accuracy & Trust</span>
            </div>
          </div>

          <p className="text-xs text-gray-550 leading-relaxed font-semibold border-b border-gray-200/80 pb-4">
            Our content is regularly updated by analyzing official taxonomical datasets. We do not make unsafe claims and advise our visitors to prioritize professional horticultural consults before handling rare plants.
          </p>

          {/* Contact Details summary */}
          <div className="space-y-3.5 pt-2 text-xs font-bold text-gray-800">
            <div className="flex items-start gap-2.5">
              <Mail className="w-4 h-4 text-green-600 shrink-0 mt-0.5" />
              <div>
                <span className="block text-gray-450 text-[10px] uppercase font-bold tracking-wider">CONTACT EMAIL</span>
                <span className="block font-black text-gray-950 break-all">contact@plantidentifer.com</span>
              </div>
            </div>
            
            <div className="flex items-start gap-2.5">
              <Clock className="w-4 h-4 text-green-600 shrink-0 mt-0.5" />
              <div>
                <span className="block text-gray-450 text-[10px] uppercase font-bold tracking-wider">SUPPORT HOURS</span>
                <span className="block text-gray-650">Monday – Friday: 9:00 AM – 5:00 PM UTC</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
